/* eslint-disable max-len */
import {
  action,
  observable,
} from 'mobx';
import {
  BaseBackendStore,
} from '../types';
import {
  emsDoctorInquiry,
} from './requests';
import {
  EmsDoctorDto,
  EmsDoctorResponse,
} from './types';
import {
  BackendStores,
} from '..';

export class EmsStore extends BaseBackendStore {
  @observable doctorsList: EmsDoctorDto[] = [];

  @observable totalCount = 0;

  @observable isLoading = false;

  @observable error: string | null = null;

  constructor(
    public parent: BackendStores,
  ) {
    super();
    this.makeObservable();
    this.registerObservableDrivers();
  }

  @action
  public searchDoctors = async (nameOrNumber: string | number): Promise<EmsDoctorResponse> => {
    const query = String(nameOrNumber ?? '').trim();
    if (!query) {
      this.doctorsList = [];
      this.totalCount = 0;
      this.error = null;
      return {
        data: [],
        count: 0,
      };
    }

    this.isLoading = true;
    this.error = null;

    try {
      const response: EmsDoctorResponse = await this.connections.backend.httpGet(
        `${emsDoctorInquiry}?name=${encodeURIComponent(query)}`,
      );
      this.doctorsList = response?.data || [];
      this.totalCount = response?.count || 0;
      this.isLoading = false;
      return response;
    } catch (err: any) {
      this.isLoading = false;
      this.doctorsList = [];
      this.totalCount = 0;
      const status = err?.response?.status;
      const message = err?.response?.data?.message || err?.message;

      if (status === 504) {
        this.error = 'EMS_TIMEOUT_ERROR';
      } else if (status === 400) {
        this.error = Array.isArray(message) ? message.join(', ') : message;
      } else {
        this.error = message || 'EMS_SEARCH_FAILED';
      }

      return Promise.reject(err);
    }
  };

  @action
  public clearResults = () => {
    this.doctorsList = [];
    this.totalCount = 0;
    this.error = null;
    this.isLoading = false;
  };
}
